import api from './api';

export const payrollService = {
    listPayslips: (workspaceId: string) =>
        api.get('/payroll/payslips', { params: { workspaceId } }),
    getPayslip: (id: string) => api.get(`/payroll/payslips/${id}`),
    getMyProfile: (workspaceId: string) =>
        api.get('/payroll/profile/me', { params: { workspaceId } }),
};
